import React, { useState, useEffect } from "react";
import Base from "../admin_components/Admin_Base";
import { Breadcrumbs, Link, TextField } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Table, Tbody, Td, Th, Thead, Tr } from "react-super-responsive-table";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import authAxios from "../Auth/useAxios";
import Swal from "sweetalert2";
import { ClipLoader } from "react-spinners";

const CustomerPropertyRejectedList = () => {
  const [customerProperties, setCustomerProperties] = useState([]);
  const [filterCustomer, setFilterCustomer] = useState("");
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  useEffect(() => {
    fetchRejectedCustomerProperties();
  }, []);

  useEffect(() => {
    if (filterCustomer) {
      setFilteredProperties(
        customerProperties.filter((property) =>
          property.customer.customerName
            .toLowerCase()
            .includes(filterCustomer.toLowerCase())
        )
      );
    } else {
      setFilteredProperties(customerProperties);
    }
  }, [filterCustomer, customerProperties]);

  const fetchRejectedCustomerProperties = async () => {
    try {
      const response = await authAxios.get(
        `${ADMIN_API_BASE_URL}/main/admin/get-all-customer-properties?customerPropertyEnum=INACTIVE`
      );

      const rejectedProperties = response.data.filter(
        (property) => property.customerPropertyEnum === "INACTIVE"
      );

      setCustomerProperties(rejectedProperties);
    } catch (error) {
      console.error("Error fetching rejected properties:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRestore = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Restore!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4CAF50",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Restore!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await authAxios.put(
            `${ADMIN_API_BASE_URL}/main/admin/${id}/update-status?customerPropertyEnum=PENDING`
          );

          if (response.status === 200) {
            setCustomerProperties((prev) =>
              prev.filter((property) => property.id !== id)
            );

            Swal.fire(
              "Updated!",
              "The property is now in PENDING status.",
              "success"
            );
          } else {
            Swal.fire("Error!", "Failed to update property status.", "error");
          }
        } catch (error) {
          console.error(
            "Error updating property status:",
            error.response?.data || error.message
          );
          Swal.fire("Error!", "Could not update the property status.", "error");
        }
      }
    });
  };


  const totalPages = Math.ceil(filteredProperties.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedRequests = filteredProperties.slice(startIndex, endIndex);


  return (
    <Base>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "300px" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          <div
            className="pt-3 mt-5 res_container"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
              className="admin_navigation"
            >
              <Link underline="hover" color="inherit" href="/admin/dashboard">
                Dashboard
              </Link>
              <Link underline="none" color="inherit" href="#">
                Customer Property Rejected List
              </Link>
            </Breadcrumbs>
          </div>

          <h2 className="text-center fw-bold main_heading">
            Customer Property Rejected List
          </h2>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <hr style={{ width: "90%" }} />
          </div>

          {/* Filter Input */}
          <div
            className="container"
            style={{ textAlign: "end", marginBottom: "10px" }}
          >
            <TextField
              label="Filter by Customer Name"
              variant="outlined"
              size="small"
              style={{ width: "250px" }}
              value={filterCustomer}
              onChange={(e) => setFilterCustomer(e.target.value)}
            />
          </div>

          <div className="container">
            <Table
              className="customer-table"
              style={{ margin: "0 auto", width: "95%" }}
            >
              <Thead style={{ backgroundColor: "darkslategrey", color: "white" }}>
                <Tr>
                  <Th>S.No</Th>
                  <Th>Customer Name</Th>
                  <Th>Property Name</Th>
                  <Th>Mobile Number</Th>
                  <Th>Passbook No</Th>
                  <Th>Plot Selected</Th>
                  <Th>Plot Direction</Th>
                  <Th>Date of Plot Purchased</Th>
                  <Th>Status</Th>
                  <Th>Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {paginatedRequests.length === 0 ? (
                  <Tr>
                    <Td colSpan={10} style={{ textAlign: "center", padding: "1rem" }}>
                      No customers found.
                    </Td>
                  </Tr>
                ) : (
                  paginatedRequests.map((property, index) => (
                    <Tr key={property.id}>
                      <Td>{index + 1}</Td>
                      <Td>{property.customer.customerName}</Td>
                      <Td>{property.propertyName}</Td>
                      <Td>{property.customer.mobileNumber}</Td>
                      <Td>{property.passbook}</Td>
                      <Td>{property.plots.plotNumber}</Td>
                      <Td>{property.plots.plotDirection}</Td>
                      <Td>{property.purchaseDate?.split("T")[0]}</Td>
                      <Td style={{ color: "red", fontWeight: "bold" }}>Rejected</Td>
                      <Td>
                        <button
                          style={{
                            backgroundColor: "#4CAF50",
                            color: "white",
                            border: "none",
                            padding: "5px 10px",
                            cursor: "pointer",
                            borderRadius: "4px",
                          }}
                          onClick={() => handleRestore(property.id)}
                        >
                          Restore
                        </button>
                      </Td>
                    </Tr>
                  ))
                )}
              </Tbody>
            </Table>
          </div>

          <div className="pagination-controls-payment-history">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span className="mx-2">
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </>
      )}
    </Base>
  );
};

export default CustomerPropertyRejectedList;
